<script lang="ts">
  export let id: string;
  export let minValue: number | null;
  export let maxValue: number | null;
  export let disabled: boolean = false;

  $: inputMinValue = minValue;
  $: inputMaxValue = maxValue;

  // Returns whether the input value is valid or not
  const isValueValid = (
    inputType: 'min' | 'max',
    inputValue: number | null
  ) => {
    if (inputValue === null) {
      return true;
    }

    const min = inputType === 'min' ? 0 : minValue || -Infinity;
    const max = inputType === 'min' ? maxValue || Infinity : Infinity;
    const validValue =
      inputValue != null ? Math.max(min, Math.min(max, inputValue)) : null;

    return inputValue === validValue;
  };

  // Validates the number input value and updates the filter values
  const validateNumberInput =
    (inputType: 'min' | 'max'): svelte.JSX.FormEventHandler<HTMLInputElement> =>
    event => {
      const inputValue = event.currentTarget.value
        ? Number(event.currentTarget.value)
        : null;
      const inputValueIsValid = isValueValid(inputType, inputValue);

      if (!inputValueIsValid) {
        // Inform user that the entered value is not valid
        event.currentTarget.reportValidity();
        return;
      }

      // Set filter values to new valid values
      if (inputType === 'min') {
        minValue = inputValue;

        const inputMaxValueIsValid = isValueValid('max', inputMaxValue);

        if (inputMaxValueIsValid && maxValue !== inputMaxValue) {
          maxValue = inputMaxValue;
        }
      } else {
        maxValue = inputValue;

        const inputMinValueIsValid = isValueValid('min', inputMinValue);

        if (inputMinValueIsValid && minValue !== inputMinValue) {
          minValue = inputMinValue;
        }
      }
    };
</script>

<style lang="postcss">
  input:invalid {
    border-color: var(--ubilabs-error-color);
  }
</style>

<div class={$$props.class}>
  <label for="{id}-min">from:</label>
  <input
    type="number"
    id="{id}-min"
    name="{id}-min"
    min={0}
    max={inputMaxValue}
    step={1}
    bind:value={inputMinValue}
    on:input={validateNumberInput('min')}
    {disabled} />

  <label for="{id}-max">to:</label>
  <input
    type="number"
    id="{id}-max"
    name="{id}-max"
    min={inputMinValue}
    step={1}
    bind:value={inputMaxValue}
    on:input={validateNumberInput('max')}
    {disabled} />
</div>
